import "reflect-metadata"
import AmplilyWidget from "./hub-grid-widget.vue"
import { AwOptions } from "../models/AwOptions"
import { exposeAmplilyWidget } from "@/services/setupAmplilyWidget"
import { createWebinarVueApp } from "./create-webinar-vueapp"
;(window as any).setupAmplilyHubGrid = (options: AwOptions, el: HTMLElement) => {
  createWebinarVueApp(AmplilyWidget, options, el)
}
exposeAmplilyWidget()
